import { render, staticRenderFns } from "./PDFImage.vue?vue&type=template&id=2a945018&"
import script from "./PDFImage.vue?vue&type=script&lang=js&"
export * from "./PDFImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports